import b from 'b_';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './switch.scss';

const Switch = (props) => {
    const { checked, children, disabled, mix, onChange, theme, view, size, labelPosition } = props;

    return (
        <div className={cx(b('switch', { theme, disabled, checked, size, view }), mix)}>
            <label className="switch__label">
                {labelPosition === Switch.LABEL_POSITIONS.LEFT && (
                    <div className={b('switch', 'text', { position: labelPosition })}>{children}</div>
                )}
                <input
                    checked={checked}
                    className="switch__checkbox"
                    disabled={disabled}
                    onChange={onChange}
                    type="checkbox"
                />
                <span className="switch__slider-wrapper">
                    <span className="switch__slider" />
                </span>
                {labelPosition === Switch.LABEL_POSITIONS.RIGHT && (
                    <div className={b('switch', 'text', { position: labelPosition })}>{children}</div>
                )}
            </label>
        </div>
    );
};

Switch.THEMES = {
    BLUE: 'blue',
    GREEN: 'green',
    LIGHT_BLUE: 'light-blue',
};

Switch.VIEWS = {
    NORMAL: 'normal',
    INVERSE: 'inverse',
};

Switch.SIZES = {
    S: 's',
    M: 'm',
    L: 'l',
};

Switch.LABEL_POSITIONS = {
    LEFT: 'left',
    RIGHT: 'right',
};

Switch.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    labelPosition: PropTypes.oneOf(Object.values(Switch.LABEL_POSITIONS)),
    mix: PropTypes.string,
    onChange: PropTypes.func,
    size: PropTypes.oneOf(Object.values(Switch.SIZES)),
    theme: PropTypes.oneOf(Object.values(Switch.THEMES)),
    view: PropTypes.oneOf(Object.values(Switch.VIEWS)),
};

Switch.defaultProps = {
    checked: false,
    view: Switch.VIEWS.NORMAL,
    size: Switch.SIZES.S,
    theme: Switch.THEMES.BLUE,
    labelPosition: Switch.LABEL_POSITIONS.LEFT,
};

export default Switch;
